import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpServiceBase } from '../../../common/services/http/httpServiceBase';

@Injectable({
    providedIn: 'root'
})
export class DevicesHttpService extends HttpServiceBase {

    constructor(protected http: HttpClient) {
        super('devices');
    }
}
